// En local: REACT_APP_API_HOST=http://localhost:8046 npm start (CRA solo expone variables REACT_APP_*)
const HOST = process.env.REACT_APP_API_HOST || 'https://monere.cl';
const API_VERSION = 'api/v1';

// Exportar buildEndpoint para usarlo directamente en hooks
export const buildEndpoint = (path: string) => `${HOST}/${API_VERSION}/${path}`;

// Obtener la URL base del backend (sin api/v1)
export const getBaseUrl = () => HOST;
